module.exports = __webpack_public_path__ + "img/featureicon2.3bd74357.svg";